import { Link as RouterLink } from 'react-router-dom';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/appRoutes.constants';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Button } from '@mui/material';

import { ANALYTICS_TAB_SLUG, type AnalyticsTab, analyticsTabPath } from './analytics.tabs';

export const AnalyticsTabLink = ({ tab }: Readonly<{ tab: AnalyticsTab }>) => (
  <Button
    id={`coaching-analytics-${ANALYTICS_TAB_SLUG[tab]}-see-more`}
    component={RouterLink}
    to={analyticsTabPath(APP_ROUTE.COACHING_ANALYTICS, tab)}
    hierarchy="Secondary gray"
    size="sm"
  >
    {appStrings.modules.coachingAnalytics.seeMore}
  </Button>
);
